import { useSupplier } from '@/api/rpc/hooks/accounts-payable/useSupplier';
import { useSupplierSearch } from '@/api/rpc/hooks/accounts-payable/useSupplierSearch';
import type { UrlFilterOption } from '@/hooks/nami/useUrlFilterTools';

/** The selected supplier as a filter option, so the context shows its name. */
export function useSupplierOptions(
  supplierId: string | undefined,
): UrlFilterOption[] {
  const { data } = useSupplier(supplierId || undefined);
  return data ? [{ id: data.id, label: data.name }] : [];
}

/** Selected suppliers as filter options, so the context shows their names. */
export function useSupplierOptionsList(
  supplierIds: readonly string[] | undefined,
): UrlFilterOption[] {
  const ids = supplierIds ?? [];
  const { data } = useSupplierSearch(
    { ids: [...ids], limit: ids.length || undefined },
    { enabled: ids.length > 0 },
  );
  return (data?.suppliers ?? []).map((supplier) => ({
    id: supplier.id,
    label: supplier.name,
  }));
}
